import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  eta: {
    id: 'eta',
    defaultMessage: 'ETA',
    description: 'ETA for the current order'
  },

  total: {
    id: 'total',
    defaultMessage: 'Total',
    description: 'No description'
  },

  tip: {
    id: 'tip',
    defaultMessage: 'Tip',
    description: 'No description'
  },

  deliveryFee: {
    id: 'deliveryFee',
    defaultMessage: 'Delivery Fee',
    description: 'No description'
  },

  serviceFee: {
    id: 'serviceFee',
    defaultMessage: 'Service Fee',
    description: 'Text label for Service Fee'
  },

  smallCartFee: {
    id: 'smallCartFee',
    defaultMessage: 'Small Cart Fee',
    description: 'Text label for Small Cart Fee'
  },

  tax: {
    id: 'tax',
    defaultMessage: 'Tax',
    description: 'No description'
  },

  subtotal: {
    id: 'subtotal',
    defaultMessage: 'Subtotal',
    description: 'No description'
  },

  yourOrder: {
    id: 'yourOrder',
    defaultMessage: 'Your Order',
    description: 'No description'
  },

  instructions: {
    id: 'instructions',
    defaultMessage: 'Instructions',
    description: 'No description'
  },

  orderTime: {
    id: 'orderTime',
    defaultMessage: 'Order time',
    description: 'No description'
  },

  paymentXEndingInY: {
    id: 'paymentXEndingInY',
    defaultMessage: 'Payment: {cardType} ending in {ccLast4}',
    description: 'No description'
  },

  orderNumber: {
    id: 'orderNumber',
    defaultMessage: 'Order number',
    description: 'No description'
  },

  orderDetailsHeading: {
    id: 'orderDetailsHeading',
    defaultMessage: 'Order Details',
    description: 'No description'
  },

  deliveringToYourDoorAt: {
    id: 'deliveringToYourDoorAt',
    defaultMessage: 'Delivering to your door at',
    description: 'No description'
  },

  free: {
    id: 'free',
    defaultMessage: 'FREE',
    description: 'No description'
  },

  deliveryStatusOrderCreated: {
    id: 'deliveryStatusOrderCreated',
    defaultMessage: 'Your order is in the works',
    description: 'No description'
  },

  deliveryStatusDriverAssigned: {
    id: 'deliveryStatusDriverAssigned',
    defaultMessage: 'Your order is in the works',
    description: 'No description'
  },

  deliveryStatusDriverUnassigned: {
    id: 'deliveryStatusDriverUnassigned',
    defaultMessage: 'Your order is in the works',
    description: 'No description'
  },

  deliveryStatusDriverStarting: {
    id: 'deliveryStatusDriverStarting',
    defaultMessage: 'Your courier is picking up your order',
    description: 'No description'
  },

  deliveryStatusDriverAtStore: {
    id: 'deliveryStatusDriverAtStore',
    defaultMessage: 'Your courier just picked up your order',
    description: 'No description'
  },

  deliveryStatusOrderPickedUp: {
    id: 'deliveryStatusOrderPickedUp',
    defaultMessage: 'Your courier is out for delivery!',
    description: 'No description'
  },

  deliveryStatusDriverAtCustomer: {
    id: 'deliveryStatusDriverAtCustomer',
    defaultMessage: 'Your courier is nearby!',
    description: 'No description'
  },

  deliveryStatusOrderDroppedOff: {
    id: 'deliveryStatusOrderDroppedOff',
    defaultMessage: 'Your order has been delivered',
    description: 'No description'
  },

  deliveryStatusOrderAbandoned: {
    id: 'deliveryStatusOrderAbandoned',
    defaultMessage: 'Your order has been delivered',
    description: 'No description'
  },

  deliveryStatusOrderCancelled: {
    id: 'deliveryStatusOrderCancelled',
    defaultMessage: 'Your order has been cancelled',
    description: 'No description'
  },

  orderPlaced: {
    id: 'orderPlaced',
    defaultMessage: 'Order Placed',
    description: 'No description'
  },

  deliveryOrderBeingPrepared: {
    id: 'deliveryOrderBeingPrepared',
    defaultMessage: 'Being Prepared',
    description: 'No description'
  },

  deliveryDriverEnroute: {
    id: 'deliveryDriverEnroute',
    defaultMessage: 'Driver Enroute',
    description: 'No description'
  },

  deliveryDelivered: {
    id: 'deliveryDelivered',
    defaultMessage: 'Delivered',
    description: 'No description'
  },

  deliveryInfo: {
    id: 'deliveryInfo',
    defaultMessage: 'Delivery Info',
    description: 'No description'
  }
});
